/* eslint-disable */
export default {
  confirmationInfo:
    'Se perderán los cambios que no haya guardado en la llamada anterior, ¿seguro que desea trabajar en una nueva llamada?',
  log: 'Registro',
  save: 'Guardar y trabajar en nueva llamada',
  discard: 'Descartar y trabajar en nueva llamada',
  stay: 'Permanecer',
} as const;

// @key: @#@"confirmationInfo"@#@ @source: @#@"Your unsaved edits on the previous call will be lost, are you sure you want to work on the new call?"@#@
// @key: @#@"log"@#@ @source: @#@"Log"@#@
// @key: @#@"save"@#@ @source: @#@"Save & Work on New"@#@
// @key: @#@"discard"@#@ @source: @#@"Discard & Work on New"@#@
// @key: @#@"stay"@#@ @source: @#@"Stay on Previous Work"@#@
